import { Button, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { brandIcons } from "./utils";

export default function FilterChip({
  filterName,
  title,
  onDelete,
  disabled,
  icon,
}) {
  const iconSrc = brandIcons[title];
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        backgroundColor: "#EDEDFC",
        borderRadius: "4px",
        padding: "4px 8px",
        width: "fit-content",
      }}
    >
      {icon && iconSrc && (
        <img
          src={iconSrc}
          alt={title}
          style={{
            width: "20px",
            height: "20px",
          }}
        />
      )}
      <Typography
        sx={{
          fontSize: "14px",
          color: "grey",
          fontWeight: 400,
          fontFamily: "Roboto, sans-serif",
        }}
      >
        {filterName}:
      </Typography>

      <Typography
        sx={{
          fontSize: "14px",
          color: "#151357",
          fontWeight: 500,
          fontFamily: "Roboto, sans-serif",
        }}
      >
        {title}
      </Typography>
      {onDelete && !disabled && (
        <Button
          onClick={onDelete}
          sx={{
            minWidth: "fit-content",
            padding: 0,
          }}
        >
          <CloseIcon
            sx={{
              color: "grey",
              width: "20px",
              height: "20px",
            }}
          />
        </Button>
      )}
    </Stack>
  );
}
